<ng-container [ngSwitch]="treatmentType">
  <app-replenish-your-good-bacteria-bacterial-vaginosis *ngSwitchCase="ConsultationTreatmentTypes.BacterialVaginosis" />
  <app-replenish-your-good-bacteria-hemorrhoids *ngSwitchCase="ConsultationTreatmentTypes.Hemorrhoids" />
  <app-replenish-your-good-bacteria-hsv *ngSwitchCase="ConsultationTreatmentTypes.Hsv" />
  <app-replenish-your-good-bacteria-metformin *ngSwitchCase="ConsultationTreatmentTypes.Metformin" />
  <app-replenish-your-good-bacteria-uti *ngSwitchCase="ConsultationTreatmentTypes.Uti" />
  <app-replenish-your-good-bacteria-yeast-infection *ngSwitchCase="ConsultationTreatmentTypes.YeastInfection" />
  <app-replenish-your-good-bacteria-zofran *ngSwitchCase="ConsultationTreatmentTypes.Zofran" />
  <app-replenish-your-good-bacteria *ngSwitchDefault />
</ng-container>
